<template>
    <div class="main">
        <!-- The Hero image and playstore link section -->
       <div class="cont">
        <div class="box">
            <div class="mesg">
                <div class="mobile_view">
                    <h1>Welcome to CABY EASY, FAST & AFFORDABLE</h1>
                    <p>
                        Ride with comfort and pleasure!
                    </p>
                    <div class="image">
                        <img src="../../assets/iphone22.png" alt="iphone">
                    </div>
                </div>
                <div class="link">
                    <div class="google">
                        <span></span>
                        <p><span class="span">Get it on</span><br>Google play</p>
                    </div>
                    <div class="apple">
                        <img src="../../assets/path4.png" alt="apple-logo">
                        <p><span>download on the</span><br>App Store</p>
                    </div>
                </div>
            </div>

            <div class="img">
                <div class="pic">
                    <img src="../../assets/BACKGROUND.png" alt="background-image">
                </div>
            </div>
        </div>
       </div>

        <!-- The text section -->
        <div class="text">
            <p>
                BETTER YOU, BETTER CITY!
            </p>
            <p>Where do you want to go today? </p>
            <p>Let us give you a comfortable ride experience.</p>
            <button>Register/Login</button>
        </div>

        

        <!-- The Images section -->
        <div class="img-box">
            <div class="ellipse">
                <img src="../../assets/Ellipse11.png" alt="pic1" class="pic1">
                <img src="../../assets/Ellipse11.png" alt="pic1"  class="pic2">
                <img src="../../assets/Ellipse11.png" alt="pic1"  class="pic3">
                <img src="../../assets/Ellipse11.png" alt="pic1"  class="pic4">
                <img src="../../assets/Ellipse11.png" alt="pic1"  class="pic5">
            </div>
            <div class="images">
                <MobileSlide />
                <!-- <div class="image">
                    <img src="../../assets/Rectangle54.png" alt="image">
                </div>
                <div class="image">
                    <img src="../../assets/Rectangle540.png" alt="image">
                </div>
                <div class="image">
                    <img src="../../assets/Rectangle544.png" alt="image">
                </div>
                <div class="image">
                    <img src="../../assets/Rectangle543.png" alt="image">
                </div> -->
            </div>  
        </div>
        
    </div>
</template>
<script>
import MobileSlide from './MobileSlide.vue';

    export default {
    name: "GetStarted",
    components: { MobileSlide }
}
</script>
<style scoped>
    .main{
        position: relative;
        width: 100%;
        margin: 0;
        padding-bottom: 0;
        margin-bottom: 2rem;
        font-family: 'Inter', sans-serif;
        /* font-family: verdana ; */
    }
    
    .main .box{
        position: relative;
        width: 100%;
        /* background-color: #011A51; */
        overflow: hidden;
        border-radius: 20px;
        /* padding: 58px 1rem; */
        display: grid;
        margin-bottom: 1rem;
    }
    .box .mesg{
        position: relative;
        margin: 0;
        color: #fff;
    }
    .box .mesg h1{
        font-weight: 600;
        letter-spacing: -0.01em;
        margin-bottom: 20px;
        text-align: center;
        line-height: 46px
    }
    .box .mesg p{
        font-weight: 400;
        line-height: 20px;
        text-align: center;
        margin-bottom: 1.7rem;
    }
    .box .mesg .image{
        position: relative;
        width: 100%;
        height: 300px;
    }
    .box .mesg .image img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .box .mesg .link{
        position: relative;
        width: 100%;
        display: flex;
        gap: 10px;
        padding: 0;
    }
    .mesg .link .google span:not(.span){
        position: relative;
        display: inline-block;
        background-color: #011A51;
        clip-path: polygon(70% 50%, 0 0, 0 100%);
        width: 25px;
        height: 25px;
        overflow: hidden;
    }
    .mesg .link .google, .mesg .link .apple{
        background-color: #fff ;
        color: #011a51;
        border-radius: 10px;
        display: flex;
        align-items: center;
        gap: 5px;
        flex: 1;
        padding: 5px;

    }
    .mesg .link .google p, .mesg .link .apple p{
        font-weight: bold;
        padding: 0;
        margin: 0;  
        line-height: 14px;
    }
    .mesg .link .google p span, .mesg .link .apple p span{
        font-size: 10px;
        font-weight: normal;
        color: #475467;
        line-height: 18px;
    }
    .box .img{
        display: none;
    }
    .main .text{
        position: relative;
        width: 100%;
        padding: 20px;
        text-align: center;
        margin-bottom: 3rem;
    }
    .main .text p:nth-child(1){
        font-weight: bold;
        color: #1b2124;
        line-height: 30px;
        font-size: 24px;
        margin-bottom: 1rem;
    }
    .main .text p{
        color: #475467;
        line-height: 22px;
        margin-bottom: 1rem;
        font-size: 14px;
    }
    .main .text button{
        border: none;
        border-radius: 10px;
        padding: 12px 30px;
        background-color: #f60;
        color: #fff;
        font-family: 'Inter', sans-serif;
    }
    
   
    .main .images{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    .images .image{
        position: relative;
        width: 100%;
        height: 260px;
        margin-bottom: 1rem;
    }
    .main .img-box{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    .img-box .ellipse{
        display: none;
    }
    @media screen and (max-width:767px) {
        
        .main .cont{
            /* background-color: #011A51; */
            position: relative;
            margin: 0;
            /* padding: 100px 1rem; */
        }
        .cont .mobile_view{
            background-color: #011A51;
            width: 100%;
            padding: 100px 1rem;
            padding-bottom: 0;
            margin-bottom: 3rem;
        }
        .box .mesg .link{

            display: flex;
            flex-direction: column;
            gap: 10px;
            /* padding: 10px; */
            justify-content: center;
            align-items: center;
        }
        .mesg .link .google, .mesg .link .apple{
                padding:10px 15px ;
                min-width: 160px;
        }
    }
    @media screen and (min-width:768px) {
        .main{
            padding: 194px 2rem;
            padding-bottom: 2rem;
        }
      
        .main .box{
            grid-template-columns: 1fr 1fr;
            padding: 0 1rem;
            gap: 2rem;
            height: 400px;
            background-color: #011A51;
            padding: 58px 1rem;
        }
        .box .mesg{
            padding: 2rem 0;
            align-self: center;
            padding-left: 2rem;
        }
        .box .mesg h1{
            font-weight: 600;
            font-size: 38px;
            line-height: 44px;
            letter-spacing: -0.01em;
            }
            .box .mesg h1{
                text-align: left;
            }
        .box .mesg p{
            font-weight: 400;
            font-size: 16px;
            line-height: 30px;
            text-align: left;
        }
        .box .mesg .image{
            display: none;
        }
        
        .box .img{
            display: unset;
            position: relative;
            width: 260px;
            margin-left: 2rem;
            height: calc(100% - 12px);
            border-radius: 50px 50px 0 0;
            top: 12px;
            background: #000000;
            box-shadow: 15px 0 35px rgba(0, 0, 0, 0.9);
            border: 2px solid #bbb;
        }
        .box .img .pic{
            position: relative; 
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            overflow: hidden;
        }
        .img .pic::after{
            content: '';
            position: absolute;
            height: 25px;
            width: 60%;
            background-color: #000;
            border-radius: 0 0 30px 30px;
            top: 15px;
            left: 50%;
            transform: translateX(-50%);
        }
        .img .pic img{
            position: absolute;
            top: 15px;
            left: 50%;
            width: 90%;
            height: calc(100% - 15px);
            transform: translateX(-50%);
            border-radius: 40px 40px 0 0;
        }
        .main .text button{
            width: 145px;
        }
        .main .text p:nth-child(1){
            font-weight: 600;
            font-size: 44px;
            line-height: 52px;
            margin-bottom: 1.2rem;
        }
        .main .text p:nth-child(2){
            line-height: 36px;
            font-size: 17px;
            margin-bottom: 1.7rem;
        }
       
    }
    @media screen and (min-width:1010px) {
        .main{
            padding: 194px 0;
            padding-bottom: 2rem;
        }
        .main .cont{
            padding: 0 4rem;
        }
        .main .box{
            padding: 0 3rem;
            min-height: 528px;
            gap: 2rem;
        }
        .box .img{
            width: 350px; 
            margin-left: 2rem;
        }
        .box .mesg{
            width: 100%;
        }
        .box .mesg h1{
            font-weight: 600;
            font-size: 60px;
            line-height: 64px;
            letter-spacing: -0.01em;
            }
        .box .mesg p{
            font-weight: 400;
            font-size: 20px;
            line-height: 28px
        }
        .main .text{
            padding: 1rem 3rem;
        }
        .main .text button{
            width: 215px;
            height: 58px;
        }
        .main .text p:nth-child(1){
            font-weight: 600;
            font-size: 60px;
            line-height: 62px;
            margin-bottom: 1.7rem;
        }
        .main .text p:nth-child(2){
            line-height: 28px;
            font-size: 20px;
            margin-bottom: 1.7rem;
        }
        .mesg .link{
            max-width: 416px;
        }
        .mesg .link .google, .mesg .link .apple{
            padding: 10px 15px;
        }
        .mesg .link .google p, .mesg .link .apple p{
            font-size: 18px;
            font-weight: 600;
        }
        .mesg .link .google p span, .mesg .link .apple p span{
            font-size: 11px;
            font-weight: 400;
        }
        .main .img-box{
            padding: 0;
        }
        .img-box .ellipse{
            display: unset;
            position: absolute;
            width: 340px;
            height: 480px;
            left: 0;
        }
        .img-box .ellipse img{
            position: absolute;
            width: 200px; 
            top: -250px;
        }
        .img-box .ellipse .pic1{
            /* left: -90.61px; */
            /* top: 0; */
            left: 0;
        }
        .img-box .ellipse .pic2{
            left: -24px
        }
        .img-box .ellipse .pic3{
            left: -50px
        }
        .img-box .ellipse .pic4{
            left: -86px;
            width: 190px;
        }
        .img-box .ellipse .pic5{
            left: -110px;
            width: 190px;
        }
        
       
    }
    @media screen and (min-width: 1280px) {
        .main{
            padding: 194px 0;
            padding-bottom: 2rem;
        }
        .main .cont{
            padding:0 6rem;
        }
        .box .img{
            width: 400px; 
            margin-left: 5rem;
        }
        .box .img .pic{
            width: 400px;
        }
        .box .mesg h1{
            font-size: 72px;
            line-height: 84px;
            letter-spacing: -0.01em;
            }
        .box .mesg p{
            font-weight: 400;
            font-size: 20px;
            line-height: 36px
        }
        .main .text p:nth-child(1){
            font-weight: 600;
            font-size: 72px;
            line-height: 83px;
            margin-bottom: 1.7rem;
        }
        .main .img-box{
            padding: 0 6rem;
        }
        .images{
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 10px;
        }
        .images .image{
            height: 280px;
        }
    }
</style>